"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortBrand = void 0;
var ShortBrand;
(function (ShortBrand) {
    ShortBrand["JochenSchweizer"] = "JS";
    ShortBrand["Mydays"] = "MD";
})(ShortBrand || (exports.ShortBrand = ShortBrand = {}));
//# sourceMappingURL=ShortBrand.js.map